import ThemeModal from "components/Common/ThemeModal"
import { Button } from "reactstrap"

const MoneyReceiptSectionEditModal = ({
  modal,
  toggleModal,
  title,
  onSubmit,
  isSubmitting = false,
  children,
}) => (
  <ThemeModal
    isOpen={modal}
    toggle={toggleModal}
    title={title}
    size="lg"
    modalBodyClass="bg-body-tertiary"
    footer={
      <div className="d-flex justify-content-end gap-2 w-100">
        <Button color="light" onClick={toggleModal}>
          Cancel
        </Button>
        <Button color="primary" onClick={onSubmit} disabled={isSubmitting}>
          {isSubmitting ? "Saving..." : "Save Changes"}
        </Button>
      </div>
    }
  >
    {children}
  </ThemeModal>
)

export default MoneyReceiptSectionEditModal
